// EXPERIMENT: psf_promote_or_share_qr_code_experiment — remove with experiment cleanup
import { useLayoutEffect, useRef } from 'react';

/**
 * The body stays mounted across steps, so a new QR or poster step would keep the grid's scroll
 * position. Back to the grid keeps it: focus returns to the QR tile, which scrolls it into view.
 */
export function useScrollBodyToTopOnStep({ isQrView, isPosterView }: { isQrView: boolean; isPosterView: boolean }) {
	const bodyRef = useRef<HTMLDivElement>(null);

	useLayoutEffect(() => {
		if (!isQrView && !isPosterView) return;
		if (bodyRef.current) bodyRef.current.scrollTop = 0;
	}, [isQrView, isPosterView]);

	return bodyRef;
}
